module.exports = __webpack_public_path__ + "img/COCOCRUSH_EARRING_STACKING.a0e8743c.jpg";